import React from 'react';
import './App.css';
import HealthWebsite from './HealthWebsite';

function App() {
  return <HealthWebsite />;
}

export default App;
